import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import MyInput from '../../components/forms/input'
import MyButton from '../../components/forms/button'

export default function Login() { 
  const navigate = useNavigate()
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    const metaTag = document.createElement('meta')
    metaTag.title = 'viewport'
  }, [])

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.username) {
      setErrorMsg({usernameEmpty: '用户名不能为空'})
      return
    }
    if (!formValue.password) {
      setErrorMsg({passwordEmpty: '密码不能为空'})
      return
    }

    axios.post('/auth/login/admin', {
      username: formValue.username,
      password: formValue.password
    })
      .then(function (response) {
        if (response.errcode === 0) {
          localStorage.setItem('token', response.data.access_token)
          navigate('/coach')
        } else if (response.errcode === 1) {
          setErrorMsg({usernameError: response.msg})
        } else if (response.errcode === 2 || response.errcode === 3) {
          setErrorMsg({pwdError: response.msg})
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <img className="auth-logo" src="/images/logo2.png" alt="柏年健身工作室" />
        </div>

        <form className="auth-loginForm">
          <MyInput
            id="username"
            autoFocus
            autoComplete='on'
            label="用户名"
            placeholder='请输入用户名'
            value={formValue.username}
            onChange={setFormValue}
            errorMsg={errorMsg.emailEmpty || errorMsg.usernameError}
          />
          <MyInput
            id="password"
            type="password"
            visibilityToggle={false}
            label="密码"
            onPressEnter={handleSubmit}
            placeholder='请输入密码'
            value={formValue.password}
            onChange={setFormValue}
            errorMsg={errorMsg.passwordEmpty || errorMsg.pwdError}
          />

          <MyButton 
            onClick={handleSubmit} 
            buttonText='登录'
            style={{ width: '200px', marginTop: '30px' }}
          />

          <div className="auth-otherLogin">
            <span className="auth-otherLine"></span>
            <span className="auth-otherLine"></span>
          </div>
          <div className='auth-signature'>
            <span>© 2025 xxxxxxxx.com, all rights reserved</span>
            <span>柏年健身工作室</span>
            <span>苏ICP备xxxxxxxx号</span>
          </div>
        </form>
      </div>
    </div>
  )
}
